import { useEffect, useState } from "react";
import Button from "../utils/Button";
import {
  aircraftPartIcon,
  arrowDown,
  arrowUp,
  locationIcon,
  planeIcon,
  verticalLine,
} from "../utils/svg";
import clsx from "clsx";
import { Modal } from "../utils/Modal";
import { useNavigate } from "react-router-dom";
import { MAX_RETRIES, MILESTONE_RETRY_TIME } from "../utils/constants";
import { MileStoneModal } from "../utils/MileStoneModal";

export const ObcOverview = (props) => {
  const {
    overviewData,
    handleSubmit,
    submitLoading,
    status,
    setIsLocation,
    coordRef,
    name,
    isGround,
    selectedAogMilestoneObject,
    setOverviewData,
    sendMilesStoneUpdateEmail,
    setSubmitLoading,
    emailStatus,
    setEmailStatus,
    submitStatus,
    setSubmitStatus,
    emailAttempts,
    setEmailAttempts,
    submitAttempts,
    setSubmitAttempts,
    userEmail,
  } = props;
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if ("geolocation" in navigator) {
      // Try to get the user's location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // Successfully got the location
          setIsLocation(true);
          coordRef.current = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
        },
        (error) => {
          // Error occurred, likely due to permission denied or other issues
          setIsLocation(false);
        }
      );
    } else {
      setIsLocation(false);
    }
  });

  const formatToLocalDateTime = (dateValue) => {
    if (!dateValue) return "-";

    const date = new Date(dateValue);

    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZoneName: "short",
    }).format(date);
  };

  const getTime = () => {
    const now = new Date();
    const hours = now.getUTCHours().toString().padStart(2, "0");
    const mins = now.getUTCMinutes().toString().padStart(2, "0");
    const sec = now.getUTCSeconds().toString().padStart(2, "0");

    return `${hours}:${mins}:${sec} GMT`;
  };

  const getTimeDate = () => {
    const now = new Date();

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = now.getUTCDate();
    const monthShort = monthNames[now.getUTCMonth()];
    const year = now.getUTCFullYear();

    return `${getTime()}| ${day} ${monthShort} ${year}`;
  };

  const currentStep = overviewData?.stages?.[0]?.milestones?.length || 0;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cooldownTime, setCooldownTime] = useState(0);
  const [isCooldownActive, setIsCooldownActive] = useState(false);
  const [afterAPIUpdatesModal, setafterAPIUpdatesModal] = useState(false);
  const [newOverviewData, setNewOverviewData] = useState();

  const moveToNextMilestone = (updatedData, submitStatus, emailStatus) => {
    if (!updatedData) {
      console.error("No data received, cannot navigate.");
      return;
    }

    setOverviewData(updatedData?.data);

    setIsModalOpen(false);
    setSubmitLoading(false);
    setafterAPIUpdatesModal(false);

    setEmailStatus("disabled");
    setSubmitStatus("disabled");
    setEmailAttempts(0);
    setSubmitAttempts(0);

    setTimeout(() => {
      const milestonePath = `/home/${
        updatedData?.data[0]?.uniqueId
      }/milestone?m=${currentStep + 1}`;

      navigate(milestonePath);
    }, 500); //  Delay for state updates
  };

  const retrySubmission = async (type) => {
    if (type === "submit") {
      await handleSubmitMilestone();
    } else if (type === "email") {
      await handleSendEmail(newOverviewData); // Pass the latest data
    }
  };

  const handleSubmitMilestone = async () => {
    setSubmitStatus("in-progress");

    try {
      // Step 1:Prepare update data
      const updateData = {
        numOfAttempts: submitAttempts,
        assignmentId: overviewData?.uniqueId,
        updatedStatus: "milestone",

        updateData: {
          stageData: {
            milestones: overviewData?.stages?.[0]?.milestones?.map(
              (milestone, index) =>
                index === 0
                  ? {
                      ...milestone,
                      status:
                        status === "completed"
                          ? milestone.status
                          : "in-progress",
                    }
                  : milestone
            ),
            location_updates: [
              {
                milestone:
                  status === "completed"
                    ? "End Assignment"
                    : "Start Assignment",
                location: `https://www.google.com/maps?q=${coordRef.current?.latitude}%2C${coordRef.current?.longitude}`,
              },
            ],
            start_date: new Date().toISOString(),
            start_time: new Date().toISOString(),
            stage_status: "In Progress",
          },
          last_updated_by: "test",
        },
      };

      // Step 3: Submit data update
      const newData = await retryApiCall(
        handleSubmit, //  Only submits milestone
        updateData,
        setSubmitStatus,
        setSubmitAttempts
      );

      if (!newData) return null;

      setNewOverviewData(newData);
      setSubmitStatus("success");

      return newData;
    } catch (err) {
      console.error("Error in handleSubmitMilestone:", err);
      setSubmitStatus("failed");
    }
  };

  const handleSendEmail = async (updatedData) => {
    setEmailStatus("in-progress");

    try {
      const emailResult = await retryApiCall(
        sendMilesStoneUpdateEmail,
        {
          numOfAttempts: emailAttempts,
          obc_assigned: userEmail,
          emailData: {
            customerName: overviewData?.customer_id?.name,
            status: "Shipment Start",
            currentTime: getTimeDate(),
            assignmentId: overviewData?.uniqueId,
            emailTo: overviewData?.customer_id?.updateEmailPrimary,
            emailCc: overviewData?.customer_id?.updateEmailSecondary?.join(","),
            emailBcc: overviewData?.customer_id?.updateEmailOthers?.join(","),
            partDimension: `${overviewData?.parts_carried?.[0]?.part_length}
                      ${
                        overviewData?.units_of_measurement?.toLowerCase() ===
                        "Imperial"?.toLowerCase()
                          ? "IN"
                          : "CM"
                      }
                      X ${overviewData?.parts_carried?.[0]?.part_width}
                       ${
                         overviewData?.units_of_measurement?.toLowerCase() ===
                         "Imperial"?.toLowerCase()
                           ? "IN"
                           : "CM"
                       }
                      X ${overviewData?.parts_carried?.[0]?.part_height}
                      ${
                        overviewData?.units_of_measurement?.toLowerCase() ===
                        "Imperial"?.toLowerCase()
                          ? "IN"
                          : "CM"
                      }`,
            partWeight: `${
              overviewData.parts_carried?.[0]?.part_weight !== undefined
                ? overviewData.parts_carried?.[0]?.part_weight +
                  " " +
                  `${
                    overviewData?.units_of_measurement?.toLowerCase() ===
                    "Imperial"?.toLowerCase()
                      ? "LBS"
                      : "KG"
                  }`
                : "-"
            }`,
            tailNumber:
              overviewData?.tail_no !== undefined ? overviewData?.tail_no : "-",
            obcName: overviewData?.stages?.[0]?.obc_name,
          },
        },
        setEmailStatus,
        setEmailAttempts
      );

      if (!emailResult) return null;

      setEmailStatus("success");
      return updatedData;
    } catch (err) {
      console.error("Error in handleSendEmail:", err);
      setEmailStatus("failed");
    }
  };

  const handleMilestoneDataAndEmailSubmission = async () => {
    try {
      // Step 1: Handle Milestone Submission
      const updatedData = await handleSubmitMilestone();

      if (!updatedData) return; // Stop if milestone submission failed

      // Step 2: Send Email
      const emailData = await handleSendEmail(updatedData);
      if (!emailData) return; // Stop if email sending failed

      // Step 3: Decide Next Steps (Move to Next Milestone or Mark Success)
      if (
        selectedAogMilestoneObject?.[currentStep]?.phase !==
        selectedAogMilestoneObject?.[currentStep + 1]?.phase
      ) {
        setOverviewData(emailData?.data);
        setSubmitLoading(false);
        setafterAPIUpdatesModal(false);

        setEmailStatus("disabled");
        setSubmitStatus("disabled");
        setEmailAttempts(0);
        setSubmitAttempts(0);
      } else {
        moveToNextMilestone(emailData, submitStatus, emailStatus); // Use the correct updated data
      }
    } catch (error) {
      console.error("Error in handleMilestoneDataAndEmailSubmission:", error);
    }
  };

  const startCooldown = () => {
    setCooldownTime(MILESTONE_RETRY_TIME); // Start 5-minute cooldown (300 seconds)
    setIsCooldownActive(true);
  };

  const retryApiCall = async (apiFunction, args, setStatus, setAttempts) => {
    try {
      setStatus("in-progress"); //  Show as "in-progress" before retrying

      const result = await apiFunction(args);

      if (result) {
        setStatus("success"); //  Mark as successful if API succeeds
        return result;
      }
    } catch (err) {
      console.error(`Retry failed.`);

      setAttempts((prev) => {
        const newAttempts = prev + 1;

        if (newAttempts >= MAX_RETRIES) {
          if (
            submitStatus === "success" &&
            emailStatus === "failed" &&
            newAttempts >= MAX_RETRIES
          ) {
            setIsModalOpen(false);
            setSubmitLoading(false);
            setafterAPIUpdatesModal(true);
          } else startCooldown(); //  Start cooldown after max retries
        }

        return newAttempts;
      });

      setStatus("failed"); //  Mark as failed after retry
      return null;
    }
  };

  return (
    <div className="bg-white rounded-lg overflow-hidden">
      {afterAPIUpdatesModal === true && (
        <MileStoneModal
          moveToNextMilestone={() =>
            navigate(`/home/${overviewData?.uniqueId}/milestone?m=1`)
          }
        />
      )}
      <div className="p-6 space-y-4">
        <h2 className="font-bold text-gray-500">Hello {name},</h2>
        <div className="border">
          <div className="bg-gray-100 rounded p-3 flex justify-between">
            <div className="flex gap-2.5 items-center">
              <p className="text-sm font-bold text-gray-500">Assignment ID</p>
              <p className="text-sm  text-gray-800">
                #{overviewData?.uniqueId}
              </p>
            </div>
            {status === "completed" ? (
              <span className="text-xs text-white bg-green-600 px-2.5 py-1.5 rounded-2xl">
                Completed
              </span>
            ) : (
              ""
            )}
          </div>
          <div className=" p-3 border-b">
            <div className="flex items-center space-x-3">
              {aircraftPartIcon()}
              <div>
                <p className="text-sm font-medium text-gray-800 ">
                  Aircraft Part- {overviewData?.parts_carried?.[0]?.part_name}
                </p>
              </div>
            </div>
            <p className="text-sm text-gray-500">
              {overviewData?.parts_carried?.[0]?.part_length}
              {overviewData?.units_of_measurement?.toLowerCase() ===
              "Imperial"?.toLowerCase()
                ? "in"
                : "cm"}{" "}
              | {overviewData?.parts_carried?.[0]?.part_width}
              {overviewData?.units_of_measurement?.toLowerCase() ===
              "Imperial"?.toLowerCase()
                ? "in"
                : "cm"}{" "}
              | {overviewData?.parts_carried?.[0]?.part_height}
              {overviewData?.units_of_measurement?.toLowerCase() ===
              "Imperial"?.toLowerCase()
                ? "in"
                : "cm"}
            </p>
          </div>
          <div className="p-3">
            <div>
              <div className="flex items-center space-x-3">
                {locationIcon()}
                <div>
                  <p className="text-sm font-medium text-gray-800">Pickup</p>
                </div>
              </div>
              <p className="text-sm text-gray-500">
                {overviewData?.stages?.[0]?.origin?.address_line1},{" "}
                {overviewData?.stages?.[0]?.origin?.city},{" "}
                {overviewData?.stages?.[0]?.origin?.zipcode},{" "}
                {overviewData?.stages?.[0]?.origin?.country}
              </p>
              {status === "completed" ? (
                <p className="text-sm text-green-600 pt-2">
                  Picked up:{" "}
                  {formatToLocalDateTime(overviewData?.stages?.[0]?.start_date)}
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="py-1">{verticalLine()}</div>
            {!isGround && status === "overview" ? (
              <div className="bg-gray-100 p-3 rounded-md">
                <div
                  onClick={() => setOpen(!open)}
                  className="text-md font-medium text-gray-500  flex justify-between items-center"
                >
                  <p className="text-sm  font-medium text-gray-500">
                    View Flight Details
                  </p>
                  <p>{open ? arrowUp() : arrowDown()}</p>
                </div>
                <div
                  className={clsx(
                    "grid overflow-hidden transition-all duration-300 ease-in-out",
                    { "grid-rows-[1fr] opacity-100": open },
                    { "grid-rows-[0fr] opacity-0": !open }
                  )}
                >
                  <div className="overflow-hidden">
                    <div className="pt-4 text-sm">
                      <div>
                        <div className="flex items-center justify-between space-x-3">
                          <div className="flex items-center space-x-3">
                            {locationIcon()}

                            <p className="text-sm font-medium text-gray-500">
                              Origin Airport
                            </p>
                          </div>
                          <div className="ml-auto">
                            <p className="text-sm text-gray-400 flex items-center">
                              {planeIcon()}
                              {overviewData?.stages?.[0]?.vehicle_number}
                            </p>
                          </div>
                        </div>
                        <p className="text-sm text-gray-400">
                          {overviewData?.stages?.[0]?.origin?.title}
                        </p>
                      </div>
                      <div className="py-1">{verticalLine()}</div>

                      {overviewData?.layover?.length > 0
                        ? overviewData?.layover?.map((layoverData) => (
                            <div>
                              <div className="flex items-center space-x-3">
                                {locationIcon()}

                                <p className=" text-sm font-medium text-gray-500">
                                  Layover At
                                </p>
                              </div>

                              <p className="text-sm text-gray-400">
                                {layoverData?.layoverName}
                              </p>
                              <div className="py-1">{verticalLine()}</div>
                            </div>
                          ))
                        : ""}
                      <div>
                        <div className="flex items-center justify-between space-x-3">
                          <div className="flex items-center space-x-3">
                            {locationIcon()}

                            <p className="text-sm font-medium text-gray-500">
                              Destination Airport
                            </p>
                          </div>
                          <div className="ml-auto">
                            <p className="text-sm text-gray-400 flex items-center">
                              {planeIcon()}
                              {overviewData?.stages?.[0]?.vehicle_number}
                            </p>
                          </div>
                        </div>
                        <p className="text-sm text-gray-400">
                          {overviewData?.stages?.[0]?.destination?.title}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {!isGround && status === "overview" ? (
              <div className="py-1">{verticalLine()}</div>
            ) : (
              ""
            )}
            <div>
              <div className="flex items-center space-x-3">
                {locationIcon()}
                <div>
                  <p className="text-sm font-medium text-gray-800">Dropoff</p>
                </div>
              </div>
              <p className="text-sm text-gray-500">
                {overviewData?.stages?.[0]?.destination?.address_line1},{" "}
                {overviewData?.stages?.[0]?.destination?.city},{" "}
                {overviewData?.stages?.[0]?.destination?.zipcode},{" "}
                {overviewData?.stages?.[0]?.destination?.country}
              </p>
              {status === "completed" ? (
                <p className="text-sm text-green-600 pt-2">
                  Dropped off:{" "}
                  {formatToLocalDateTime(overviewData?.stages?.[0]?.end_date)}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
          {status === "overview" ? (
            <div className="p-3 border-t">
              <Button
                text={"Start"}
                size={"md"}
                loading={submitLoading}
                onClick={() => {
                  setIsModalOpen(true);
                }}
              />
              <Modal
                isOpen={isModalOpen || submitLoading}
                header={"Begin Assignment"}
                message={"Start your shipment delivery assignment "}
                isCross={true}
                crossAction={() => setIsModalOpen(false)}
                buttonTitle={"Confirm"}
                submitStatus={submitStatus}
                emailStatus={emailStatus}
                submitAttempts={submitAttempts} // Tracks retry count for milestone update
                emailAttempts={emailAttempts} // Tracks retry count for email update
                maxRetries={MAX_RETRIES}
                closeModal={() => setIsModalOpen(false)}
                retrySubmission={retrySubmission}
                milestoneName={"Assignment Initiated"}
                milestoneDescription={
                  "Loading milestones & processing assignment details"
                }
                moveToNextMilestone={moveToNextMilestone}
                MAX_RETRIES={MAX_RETRIES}
                cooldownTime={cooldownTime}
                isCooldownActive={isCooldownActive}
                isGround={isGround}
                currentStep={currentStep}
                // function to submit the current details

                buttonAction={handleMilestoneDataAndEmailSubmission}
                isLoading={submitLoading}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
